var _desc, _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAddPoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "49aadcbe-f650-4cf8-bb7f-df3a1daee9c0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "3a786868-1da7-4b1a-aa10-cf5aabbef393"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.54 0 0 4.54 540 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 10.95 -41.51)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(85,85,85)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-205.8, -158.8)",
    d: "M 205.82 208.31 C 233.12 208.31 255.32999999999998 186.09 255.32999999999998 158.8 C 255.32999999999998 131.51000000000002 233.11999999999998 109.29000000000002 205.82 109.29000000000002 C 178.52 109.29000000000002 156.26999999999998 131.51000000000002 156.26999999999998 158.8 C 156.26999999999998 186.09 178.51999999999998 208.31 205.82 208.31 Z M 205.82 115.63 C 229.62 115.63 248.98 134.98 248.98 158.79 C 248.98 182.6 229.63 201.95 205.82 201.95 C 182.01 201.95 162.63 182.6 162.63 158.79 C 162.63 134.98 182.01999999999998 115.63 205.82 115.63 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 10.95 -41.52)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(85,85,85)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-205.8, -158.79)",
    d: "M 205.82 193.4 C 224.89 193.4 240.39999999999998 177.89000000000001 240.39999999999998 158.79000000000002 C 240.39999999999998 139.69000000000003 224.89 124.18000000000002 205.82 124.18000000000002 C 186.75 124.18000000000002 171.20999999999998 139.72000000000003 171.20999999999998 158.79000000000002 C 171.20999999999998 177.86 186.74999999999997 193.40000000000003 205.82 193.40000000000003 Z M 191.01 152.66 L 197.87 151.64 C 198.82 151.51 199.65 150.91 200.1 150.01999999999998 L 203.15 143.82 C 204.23000000000002 141.63 207.38 141.63 208.46 143.82 L 211.51000000000002 150.01999999999998 C 211.96 150.90999999999997 212.78000000000003 151.51 213.74 151.64 L 220.60000000000002 152.66 C 223.02 153.01 223.97000000000003 155.97 222.22000000000003 157.68 L 217.26000000000002 162.51000000000002 C 216.56000000000003 163.18 216.24 164.16000000000003 216.43 165.12000000000003 L 217.57 171.95000000000005 C 217.98 174.36000000000004 215.47 176.21000000000004 213.31 175.06000000000006 L 207.18 171.82000000000005 C 206.32 171.37000000000006 205.27 171.37000000000006 204.41 171.82000000000005 L 198.28 175.06000000000006 C 196.12 176.20000000000005 193.61 174.36000000000007 194.02 171.95000000000005 L 195.20000000000002 165.12000000000003 C 195.36 164.17000000000004 195.04000000000002 163.18000000000004 194.34 162.51000000000002 L 189.38 157.68 C 187.63 155.96 188.59 153.01000000000002 191 152.66 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -46.6 -83.38)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(85,85,85)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-148.25, -116.94)",
    d: "M 147.82 121.24 C 148.98 122.55 150.98999999999998 122.67999999999999 152.31 121.50999999999999 C 153.62 120.33999999999999 153.74 118.33999999999999 152.58 117.02 L 148.69000000000003 112.63 C 147.53000000000003 111.32 145.52000000000004 111.19999999999999 144.20000000000002 112.36 C 142.89000000000001 113.53 142.77 115.53 143.93 116.85 L 147.82 121.24 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -33.23 -95.25)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(85,85,85)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-161.62, -105.06)",
    d: "M 162.53 111.1 C 164.26 110.83999999999999 165.46 109.22 165.2 107.49 L 164.32999999999998 101.69 C 164.07 99.95 162.45 98.75 160.71999999999997 99.02 C 158.98999999999998 99.28 157.78999999999996 100.89999999999999 158.04999999999998 102.63 L 158.92 108.42999999999999 C 159.17999999999998 110.17999999999999 160.82 111.36999999999999 162.53 111.1 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -60 -71.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(85,85,85)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-134.86, -128.82)",
    d: "M 131.2 131.11 L 136.85 132.66000000000003 C 138.51999999999998 133.12000000000003 140.29 132.14000000000001 140.75 130.43000000000004 C 141.21 128.74000000000004 140.22 126.99000000000004 138.52 126.53000000000003 L 132.87 124.98000000000003 C 131.17000000000002 124.51000000000003 129.43 125.51000000000003 128.97 127.21000000000004 C 128.51 128.91000000000003 129.5 130.65000000000003 131.2 131.11000000000004 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 68.5 -83.38)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(85,85,85)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-263.36, -116.94)",
    d: "M 263.79 121.24 L 267.68 116.85 C 268.85 115.53999999999999 268.73 113.53 267.41 112.36 C 266.1 111.2 264.09000000000003 111.32 262.92 112.63 L 259.03000000000003 117.02 C 257.86 118.33 257.98 120.33999999999999 259.3 121.50999999999999 C 260.62 122.67999999999999 262.63 122.55 263.79 121.24 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 55.12 -95.25)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(85,85,85)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-249.97, -105.06)",
    d: "M 249.07 111.1 C 250.79 111.36999999999999 252.42 110.16999999999999 252.68 108.42999999999999 L 253.55 102.63 C 253.81 100.89999999999999 252.61 99.28 250.88000000000002 99.02 C 249.14000000000001 98.75 247.53000000000003 99.96 247.27 101.69 L 246.4 107.49 C 246.14000000000001 109.22 247.34 110.83999999999999 249.07 111.1 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 81.89 -71.49)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(85,85,85)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-276.75, -128.82)",
    d: "M 274.76 132.66 L 280.40999999999997 131.10999999999999 C 282.09999999999997 130.64999999999998 283.09999999999997 128.89999999999998 282.64 127.20999999999998 C 282.18 125.51999999999998 280.43 124.50999999999998 278.74 124.97999999999998 L 273.09000000000003 126.52999999999997 C 271.40000000000003 126.98999999999997 270.40000000000003 128.73999999999998 270.86 130.42999999999998 C 271.33000000000004 132.14 273.1 133.11999999999998 274.76 132.65999999999997 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 54.01)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(85,85,85)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-194.85, -254.32)",
    d: "M 292.64 231.7 C 288.47999999999996 227.08999999999997 281.96 225.57 276.24 227.66 C 272.73 220.64 264.56 218.66 258.47 222.1 L 255.61 223.75 C 257.33000000000004 219.59 256.63 214.66 253.45000000000002 211.1 C 249.22000000000003 206.29999999999998 241.98000000000002 205.63 236.92000000000002 209.51 L 203.65 235.25 L 186.68 224.57 C 170.69 213.19 145.65 221.35999999999999 144.57 221.73999999999998 L 129.7 226.95 C 129.54 222.63 125.97999999999999 219.16 121.6 219.16 L 101.22999999999999 219.16 C 96.77999999999999 219.16 93.16 222.78 93.16 227.26 L 93.16 282.53 C 93.16 286.97999999999996 96.78 290.63 101.22999999999999 290.63 L 121.6 290.63 C 125.75999999999999 290.63 129.2 287.48 129.64 283.45 C 146.7 288.57 144.85 292.11 157.07 297.21 C 173.07 303.84 199.53 303.69 221.68 292.15999999999997 L 288.77 255.03999999999996 C 297.40999999999997 250.24999999999997 299.07 238.75999999999996 292.65 231.67999999999995 Z M 159.55 291.35 C 148.48000000000002 286.76000000000005 148.57000000000002 282 129.71 276.86 L 129.71 233.67000000000002 L 146.62 227.76000000000002 C 146.87 227.70000000000002 169.63 220.23000000000002 183.17000000000002 229.86 C 186.58 232 170.83 222.09 216.48000000000002 250.84 C 219.31000000000003 252.4 221.12 255.78 220.13000000000002 259.71 C 218.82000000000002 264.04999999999995 214.23000000000002 266.34 209.96000000000004 264.66999999999996 C 196.52000000000004 259.37999999999994 186.65000000000003 255.47999999999996 181.74000000000004 253.54999999999995 C 180.12000000000003 252.90999999999997 178.28000000000003 253.70999999999995 177.64000000000004 255.35999999999996 C 176.97000000000006 256.97999999999996 177.80000000000004 258.81999999999994 179.42000000000004 259.46 L 207.64000000000004 270.58 C 215.20000000000005 273.59999999999997 223.87000000000003 269.44 226.20000000000005 261.52 C 226.23000000000005 261.39 226.26000000000005 261.29999999999995 226.30000000000004 261.16999999999996 C 296.29 224.10999999999996 272.15000000000003 236.88999999999996 277.37000000000006 234.12999999999997 C 277.40000000000003 234.09999999999997 277.46000000000004 234.09999999999997 277.50000000000006 234.06999999999996 C 281.00000000000006 232.28999999999996 285.2900000000001 233.04999999999995 287.9200000000001 235.97999999999996 C 291.75000000000006 240.20999999999995 290.5900000000001 246.80999999999997 285.70000000000005 249.51999999999995 L 218.71000000000004 286.5799999999999 C 195.61000000000004 298.5899999999999 170.69000000000003 296.04999999999995 159.57000000000005 291.37999999999994 Z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddPoint);
export default __webpack_public_path__ + "static/media/ic_addPoint.7a869b289bbc0f692e84af9a2862dd25.svg";
export { ForwardRef as ReactComponent };